
import React from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Terms from "../pages/terms/page";
import Accessibility from "../pages/accessibility/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: React.createElement(Home),
  },
  {
    path: "/privacy-policy",
    element: React.createElement(PrivacyPolicy),
  },
  {
    path: "/terms",
    element: React.createElement(Terms),
  },
  {
    path: "/accessibility",
    element: React.createElement(Accessibility),
  },
  {
    path: "*",
    element: React.createElement(NotFound),
  },
];

export default routes;
